import GoogleMap from 'google-map-react';
import PropTypes from 'prop-types';
import React from 'react';
import MapMarker from 'src/components/ElementMap/MapMarker';
import MapStyle from 'src/components/ElementMap/MapStyle';

function ElementMap({ office }) {
  const offices = {
    Budapest: {
      zoom: 14,
      center: {
        lat: 47.50466150501315,
        lng: 19.03752458453747,
      },
      marker: {
        lat: 47.51171493939789,
        lng: 19.05306281149272,
      },
    },
    Chicago: {
      zoom: 13,
      center: {
        lat: 41.9658907,
        lng: -87.6865231,
      },
      marker: {
        lat: 41.9658907,
        lng: -87.6865231,
      },
    },
  };

  const selectedOffice = offices[office] || offices.Budapest;

  return (
    <GoogleMap
      apiKey={process.env.GATSBY_GOOGLE_MAPS_KEY}
      zoom={selectedOffice.zoom}
      center={selectedOffice.center}
      options={{
        styles: MapStyle,
      }}
    >
      <MapMarker {...selectedOffice.marker} />
    </GoogleMap>
  );
}

ElementMap.propTypes = {
  office: PropTypes.string.isRequired,
};

export default ElementMap;
